/**
 * Emanet kaydındaki lastik ÇEŞİDİ özeti.
 *
 * VERİ MODELİ: bir emanet kaydı (`storages`) birden fazla lastik çeşidi
 * içerebilir; çeşitler `items` JSONB dizisinde tutulur (her eleman bir
 * marka/ebat/adet/sezon grubudur). Eski kayıtlarda `items` yoktur; o
 * kayıtlarda üst seviyedeki `brand`/`size` alanları TEK çeşidi temsil eder.
 *
 * Bu yüzden "çeşit sayısı" = items.length, items yoksa 1'dir. `quantity`
 * (toplam lastik ADEDİ) ile karıştırılmamalıdır.
 *
 * Emanetler listesi ve Raporlar > Emanetler aynı gösterimi kullansın diye
 * ortak dosyada.
 */

/** Kayıttaki lastik çeşidi sayısı. */
export function tyreKindCount(storage) {
  const items = storage?.items;
  if (Array.isArray(items) && items.length) return items.length;
  return 1;
}

/**
 * Liste sütunlarında gösterilecek metin:
 *   • tek çeşit  → mevcut "Marka / Ebat" gösterimi korunur
 *   • çok çeşit  → "3 Çeşit Lastik"
 */
export function tyreSummary(storage, { separator = " / " } = {}) {
  const count = tyreKindCount(storage);
  if (count > 1) return `${count} Çeşit Lastik`;
  const items = storage?.items;
  const first = Array.isArray(items) && items.length ? items[0] : storage;
  return [first?.brand, first?.size].filter(Boolean).join(separator) || "—";
}
